<template>
  <div>
    <a-drawer
      title="担保合同修改内容"
      placement="right"
      :closable="true"
      :visible="visible"
      :mask="false"
      width="500"
      @close="closeDrawer"
    >
      <div>
        <span v-for="(record, index) in guaranteeContractRecordList" :key="index">
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['name']">名称：{{ parseGuaranteeContractRecord(record['modify_record'])['name']['before'] }} -> {{ parseGuaranteeContractRecord(record['modify_record'])['name']['after'] }}</span>
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['client']">客户：{{ parseGuaranteeContractRecord(record['modify_record'])['client']['before'] }} -> {{ parseGuaranteeContractRecord(record['modify_record'])['client']['after'] }}</span>
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['guarantee_method']">担保方式：
            {{ dictionaries.guarantee_method[parseGuaranteeContractRecord(record['modify_record'])['guarantee_method']['before']] }} -> {{ dictionaries.guarantee_method[parseGuaranteeContractRecord(record['modify_record'])['guarantee_method']['after']] }}
          </span>
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['collateral']">抵押物：{{ parseGuaranteeContractRecord(record['modify_record'])['collateral']['before'] }} -> {{ parseGuaranteeContractRecord(record['modify_record'])['collateral']['after'] }}</span>
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['pledged_goods']">质押物：{{ parseGuaranteeContractRecord(record['modify_record'])['pledged_goods']['before'] }} -> {{ parseGuaranteeContractRecord(record['modify_record'])['pledged_goods']['after'] }}</span>
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['storage_location']">存放地：{{ parseGuaranteeContractRecord(record['modify_record'])['storage_location']['before'] }} -> {{ parseGuaranteeContractRecord(record['modify_record'])['storage_location']['after'] }}</span>
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['collateral_pledged_goods_value']">抵/质押货物价值：{{ parseGuaranteeContractRecord(record['modify_record'])['collateral_pledged_goods_value']['before'] }} -> {{ parseGuaranteeContractRecord(record['modify_record'])['collateral_pledged_goods_value']['after'] }}</span>
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['registration_method']">登记方式：{{ parseGuaranteeContractRecord(record['modify_record'])['registration_method']['before'] }} -> {{ parseGuaranteeContractRecord(record['modify_record'])['registration_method']['after'] }}</span>
          <span class="desc" v-if="parseGuaranteeContractRecord(record['modify_record'])['guarantee_period_start_date'] && parseGuaranteeContractRecord(record['modify_record'])['guarantee_period_end_date']">担保期限：{{ guaranteePeriodBefore(parseGuaranteeContractRecord(record['modify_record'])) }} -> {{ guaranteePeriodAfter(parseGuaranteeContractRecord(record['modify_record'])) }}</span>
        </span>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { Dictionaries } from '@/common/AllConstant'
import { guarantee_contract_record_list } from '@/api/trade_contract'

export default {
  name: 'GuaranteeContractRecord',
  props: {
    contract: {
      type: Object,
      default () {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parseGuaranteeContractRecord () {
      return (record) => {
        return JSON.parse(record)
      }
    },
    guaranteePeriodBefore () {
      return (record) => {
         const before_start_date = record['guarantee_period_start_date']['before'] === '1970-01-01' ? undefined : record['guarantee_period_start_date']['before']
         const before_end_date = record['guarantee_period_end_date']['before'] === '1970-01-01' ? undefined : record['guarantee_period_end_date']['before']
        if (before_start_date && before_end_date) {
          return before_start_date + '~' + before_end_date
        } else {
          return '无'
        }
      }
    },
    guaranteePeriodAfter () {
      return (record) => {
        const after_start_date = record['guarantee_period_start_date']['after'] === '1970-01-01' ? undefined : record['guarantee_period_start_date']['after']
        const after_end_date = record['guarantee_period_end_date']['after'] === '1970-01-01' ? undefined : record['guarantee_period_end_date']['after']
        if (after_start_date && after_end_date) {
          return after_start_date + '~' + after_end_date
        } else {
          return '无'
        }
      }
    }
  },
  data () {
    return {
      loading: false,
      dictionaries: Dictionaries,
      guaranteeContractRecordList: []
    }
  },
  mounted () {
    this.loadModifyRecord()
  },
  methods: {
    closeDrawer () {
      this.$emit('close')
    },
    loadModifyRecord () {
      this.loading = true
      guarantee_contract_record_list({ contract_number: this.contract.number, to_version: this.contract.version }).then(res => {
        if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
          this.guaranteeContractRecordList = res.data.entries || []
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: block;
}
</style>
